/**
 * 权限自定义指令
 * 用于控制元素的显示/隐藏
 *
 * 使用方法：
 * 1. 单个角色：v-permission="'village'"
 * 2. 多个角色：v-permission="['admin', 'county']"
 * 3. 角色级别及以上：v-permission="'>=town'" (乡镇级及以上)
 * 4. 仅管理员：v-permission="'super_admin'"
 */
import { getRoleType } from '@/utils/permission'

/**
 * 角色层级权重
 */
const roleHierarchy = {
  super_admin: 4,
  county: 3,
  town: 2,
  village: 1
}

/**
 * 检查权限
 * @param {string|string[]} value - 指令值
 * @returns {boolean} 是否有权限
 */
function checkPermission(value) {
  const currentRole = getRoleType()
  if (!currentRole) return false

  // 未设置值，默认允许
  if (!value) return true

  if (Array.isArray(value)) {
    // 多个角色：v-permission="['admin', 'county']"
    return value.includes(currentRole)
  }

  if (typeof value === 'string') {
    // 角色级别及以上：v-permission="'>=town'"
    if (value.startsWith('>=')) {
      const requiredRole = value.substring(2).trim()
      const currentLevel = roleHierarchy[currentRole] || 0
      const requiredLevel = roleHierarchy[requiredRole] || 0
      return currentLevel >= requiredLevel
    }

    // 单个角色：v-permission="'village'"
    return currentRole === value
  }

  return false
}

export default {
  /**
   * 元素插入DOM时检查权限
   */
  inserted(el, binding) {
    const { value } = binding
    if (!checkPermission(value)) {
      // 无权限，移除元素
      el.parentNode && el.parentNode.removeChild(el)
    }
  },

  /**
   * 组件更新时重新检查权限（支持动态权限）
   */
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      const { value } = binding
      if (!checkPermission(value)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  }
}
